import axios from '@/utils/axios'

// GET ALL
export const getStorePersons = (params = {}) => {
  return axios.get('/store-persons', { params })
}

// GET BY ID
export const getStorePersonById = (id) => {
  return axios.get(`/store-persons/${id}`)
}

// DROPDOWN
export const getStorePersonDropdown = () => {
  return axios.get('/store-persons/dropdown')
}

// CREATE
export const createStorePerson = (data) => {
  return axios.post('/store-persons', data)
}

// UPDATE
export const updateStorePerson = (id, data) => {
  return axios.put(`/store-persons/${id}`, data)
}

// DELETE
export const deleteStorePerson = (id) => {
  return axios.delete(`/store-persons/${id}`)
}